import { Page } from './pages.d';

const page: Page = {
  slug: '404',
  title: 'Pagina niet gevonden',
  text: `
    <p>
      Helaas deze pagina kon niet worden gevonden.
    </p>

    <a href="/" class="btn btn-primary">
      Terug naar home
    </a>
  `,
};

export default page;
